import React, { useEffect, useState } from 'react';
import { Container, Form, Header, Icon, Breadcrumb, Button, Grid, Input, Segment, Message, Checkbox, FormField } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { useHistory, useLocation, useParams } from 'react-router';
import { usePublicCASASTestingForm } from './usePublicCASASTestingForm';
import moment from 'moment';

export function EditCASASTestingForm() {
    let { WId } = useParams<{ WId: string }>();
    let [values, masterData, errors, touched, isLoading, isSubmitting, isValid, submitSuccess, errorMessage, registerRef, handleChange, handleBlur, handleSubmit] = usePublicCASASTestingForm();
    const history = useHistory();
    //console.log(masterData);

    function handleBackToList() {
        history.push('/CASASTestingList');
    }

    return <Container className='providers-container'>
        <Header as='h1' style={{ marginTop: '2.0rem', marginBottom: '0.5rem' }}>Register CASAS Testing</Header>
        <hr style={{ marginBottom: '1.0rem' }} />
        <Breadcrumb style={{ marginBottom: '1.0rem' }}>
            <Breadcrumb.Section link><Link to='/dashboard'>Home</Link></Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section active>Register CASAS Testing</Breadcrumb.Section>
        </Breadcrumb>


        <Grid columns={2} style={submitSuccess ? { margin: 0 } : {}}>
            {
                !submitSuccess &&
                <>
                    <Grid.Column>
                        <Form loading={isSubmitting}>
                            <Form.Field>
                                <label>First Name</label>
                                <p style={{ width: '100%', padding: '0.5rem', border: '1px solid lightgray', borderRadius: '4px', color: 'gray' }}>
                                    {values.firstName}
                                </p>
                            </Form.Field>
                            <Form.Field>
                                <label>Last Name</label>
                                <p style={{ width: '100%', padding: '0.5rem', border: '1px solid lightgray', borderRadius: '4px', color: 'gray' }}>
                                    {values.lastName}
                                </p>
                            </Form.Field>
                            <Form.Field>
                                <label>Email</label>
                                <p style={{ width: '100%', padding: '0.5rem', border: '1px solid lightgray', borderRadius: '4px', color: 'gray' }}>
                                    {values.email}
                                </p>
                            </Form.Field>
                            <Form.Field>
                                <label>Registered Date</label>
                                <p style={{ width: '100%', padding: '0.5rem', border: '1px solid lightgray', borderRadius: '4px', color: 'gray' }}>
                                    {values.registeredTime}
                                </p>
                            </Form.Field>
                            {
                                values.phoneNUmber &&
                                <Form.Field>
                                    <label>Phone Number</label>
                                    <p style={{ width: '100%', padding: '0.5rem', border: '1px solid lightgray', borderRadius: '4px', color: 'gray' }}>
                                        {values.phoneNumber}
                                    </p>
                                </Form.Field>
                            }
                            {
                                values.counselorComments &&
                                <Form.Field>
                                    <label>Comments by {values.counselorName}</label>
                                    <p style={{ width: '100%', padding: '0.5rem', border: '1px solid lightgray', borderRadius: '4px', color: 'gray', minHeight: '2rem' }}
                                        dangerouslySetInnerHTML={{__html: values.counselorComments.replaceAll('\n', '<br />')}}
                                    >
                                    </p>
                                </Form.Field>
                            }


                            <FormField>
                                <Checkbox label='CASAS Testing Completed' checked={values.casastestingCompleted}
                                    onChange={() => {

                                        if (values.casastestingCompleted === false && values.noShowForTesting === true) {
                                            handleChange(false, 'noShowForTesting');
                                        }
                                        if(values.casastestingCompleted === true){
                                            handleChange(null, 'testingCompletedDate');
                                        }
                                        handleChange(!values.casastestingCompleted, 'casastestingCompleted');

                                    }}
                                />
                            </FormField>
                            {
                                values.casastestingCompleted === true &&
                                <>
                                    <Form.Input className={!(!errors.testingCompletedDate || !touched.testingCompletedDate) ? 'mb-0' : ''}
                                        fluid
                                        type='date'
                                        label='Testing Completed Date'
                                        placeholder='mm/dd/yyyy'
                                        required={true}
                                        value={values.testingCompletedDate}
                                        onChange={(event, data) => {
                                            handleChange(data.value, 'testingCompletedDate');
                                        }}
                                        onBlur={
                                            () => { handleBlur('testingCompletedDate') }
                                        }
                                        error={!(!errors.testingCompletedDate || !touched.testingCompletedDate) ? true : false}
                                    />
                                    {
                                        !(!errors.testingCompletedDate || !touched.testingCompletedDate) &&
                                        <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.testingCompletedDate}</div>
                                    }
                                </>
                            }

                            <FormField>
                                <Checkbox label='No Show For Testing' checked={values.noShowForTesting}
                                    onChange={() => {
                                        if (values.noShowForTesting === false && values.casastestingCompleted === true) {
                                            handleChange(false, 'casastestingCompleted');
                                        }
                                        if(values.noShowForTesting === false){
                                            handleChange(null, 'testingCompletedDate');
                                        }
                                        handleChange(!values.noShowForTesting, 'noShowForTesting');
                                    }}
                                />
                            </FormField>
                            <Form.TextArea className={!(!errors.staffComments || !touched.staffComments) ? 'mb-0' : ''}
                                fluid
                                label='Comments'
                                value = {values.staffComments}
                                onChange={(event, data) => {
                                    handleChange(data.value, 'staffComments');
                                }}
                                onBlur={
                                    () => { handleBlur('staffComments') }
                                }
                                error={!(!errors.staffComments || !touched.staffComments) ? true : false}
                            />
                            {
                                !(!errors.staffComments || !touched.staffComments) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.staffComments}</div>
                            }
                            <Button type='button' loading={isSubmitting} primary onClick={handleSubmit}>Submit</Button>
                            <Button type='button' onClick={() => { history.push('/CASASTestingList') }}>Cancel</Button>
                        </Form>
                    </Grid.Column>
                    <Grid.Column>
                    </Grid.Column>
                </>
            }
            {
                submitSuccess &&
                <Message icon positive>
                    <Icon name='check circle outline' color='green' />
                    <Message.Content>
                        <Message.Header>Success</Message.Header>
                        <div>You have successfully updated the CASAS testing.</div>
                        <div style={{ marginTop: '0.5rem' }}>
                            <Button icon labelPosition='left' size='small' onClick={handleBackToList}>
                                <Icon name='arrow circle left' />
                                <span>Back to CASAS testing list</span>
                            </Button></div>
                    </Message.Content>
                </Message>
            }

        </Grid>

    </Container>
}